var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUruguay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "25px",
    viewBox: "0 0 50 25",
    enableBackground: "new 0 0 50 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 50,
    height: 25,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAZCAMAAABEio12AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB5lBMVEX////+/v3///7+/v7/ /v7+/v/8/P78/f7+/fz7+vn9/fzbybPz7urYxav6+PbUv6f9/Pvi6PW/zenE0evD0Ovn3NDr4M3X xbHKqmrgz7LIpWDGqXzcw4n7/P/byrH6+/2CntQAJqAAOKgANab8+/r69/PHq4LPrmetex2dZw+x fxSfaAjDnlnAm1nj1cLl2Mn18Ov8/f98mdIAHJwAL6QAK6LZyLTPs4DPr2iaYga2gQfIlgvjtBCz fwurcwC0hzXGpGXgzrP9/f79/v+7yuhnict0ktBxkc/49fPj1cHPs4SvfyWvegXXpxLltxPqvRTB jg6dZgbOrm3k18Pt5Nv59vLt5dzfzau3iCiYYAPswBXtwBXYqRH80Re8iQ2qdAe7lFDZxaTw6uPt 5NzNr3bDoWiyfQujbAXJlwrHlAm/jAygZwC0iTzcxI3Pt5Pt5d2uwONKcsFZfcZWe8Xu5tzu5+PJ qna0hi6qdxSreh+hawvFolzIp2nj1sn7+fb7/P4AG5sALqTo3tS5kEngz6+/m2D479O3kVf28u7i 1MH69/X7+/2HodYKQKsGPar8/Pz+///s5Nvh1cn39PHVw6zo3tLv6eP8/f3r8PjW3/HZ4fLY4fLa 4vLa4vPZ4fDa4fHZ4vIGPKoLvQlrAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+YFGxUUEoTLylcAAAE8 SURBVDjLY2AAA0YmBgZmFgiblY0dL4Co4gAiTgYGLmaQDgYiAFAhNwMPLx8/A4MAUIegkLAIPgDW IyomLiEpJS0jK8fAIM+goKikjA8ANaioMqipa2hqaevo6ukbGDIYGZuY4gMgS8zMLSytrG1s7ewd HJ2cGVxc3dzxAaAOD08vbx9fP3+/gMCg4BBGYrwfGhYeERkVHRMbF5+QmMRCVIglp6SmpWdkZmXn 5OblMzAUFBYV4wMgLSWl5mXlFZVV1TW1DHX1DEYNjYS8z8xQ0sTQ3NLa1t7R2cXQzdDT2NuHDzA4 OTn3T2CYOGnyFIap0ximO7EzzJg5azY+gOQlJmL8DQJzQGDunHlz58ydD6SB7AWz8QMGuBMX9hEJ GExJBgzFJANivUwhcCcZkON9ZZIBgwjJgBzvs5MMAHQP+O1Rc+ueAAAAJXRFWHRkYXRlOmNyZWF0 ZQAyMDIyLTA1LTI3VDIxOjIwOjE4KzAwOjAwrlKgagAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0w NS0yN1QyMToyMDoxOCswMDowMN8PGNYAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.9b71001adf4b6dd8390ed16f3e97e9d4.svg";
export { ForwardRef as ReactComponent };